import { FirmStatus } from "@azm/features/auth/enums/firm-status";
import type { IBusinessAccountsResponse, IFirm } from "@azm/features/auth/interfaces/business";

export function coerceBusinessAccountsFromTokenAccess(payload: unknown): IBusinessAccountsResponse | null {
	if (payload == null || typeof payload !== "object") return null;
	const o = payload as Record<string, unknown>;
	const bucket = ("data" in o && typeof o["data"] === "object" && o["data"] != null ? o["data"] : o) as Record<string, unknown>;
	const userId = bucket["userId"] ?? bucket["UserId"];
	if (userId == null || String(userId).trim() === "") return null;
	return {
		userId: String(userId),
		activeFirms: (bucket["activeFirms"] ?? bucket["ActiveFirms"]) as IFirm[] | undefined,
		inActiveFirms: (bucket["inActiveFirms"] ?? bucket["InActiveFirms"]) as IFirm[] | undefined,
		ActiveFirms: bucket["ActiveFirms"] as IFirm[] | undefined,
		InActiveFirms: bucket["InActiveFirms"] as IFirm[] | undefined,
	};
}

export function isFirmEligibleForBusinessLogin(f: IFirm | null | undefined): boolean {
	return !!f && f.status === FirmStatus.Active && f.needUpdate !== true;
}

export function eligibleActiveBusinessFirmsForLogin(accounts: IBusinessAccountsResponse): IFirm[] {
	const list = accounts.activeFirms ?? accounts.ActiveFirms ?? [];
	return list.filter(isFirmEligibleForBusinessLogin);
}

export function soleEligibleActiveBusinessFirmForSso(accounts: IBusinessAccountsResponse): IFirm | null {
	const eligible = eligibleActiveBusinessFirmsForLogin(accounts);
	return eligible.length === 1 ? eligible[0]! : null;
}
